import { createFileRoute } from "@tanstack/react-router";
import { HelpLink, HelpNote, HelpPage, HelpSection } from "@/components/HelpPage";

export const Route = createFileRoute("/echanges-retours")({
  head: () => ({
    meta: [
      { title: "Échanges & retours — Sunset Concept Store" },
      {
        name: "description",
        content:
          "Comment demander un échange ou un retour chez Sunset Concept Store : conditions, articles endommagés et contact de notre équipe.",
      },
      { property: "og:title", content: "Échanges & retours — Sunset Concept Store" },
      {
        property: "og:description",
        content: "Demande d'échange ou de retour : conditions et accompagnement par l'équipe Sunset Concept Store.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://sunsetconcept.store/echanges-retours" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://sunsetconcept.store/echanges-retours" }],
  }),
  component: EchangesRetoursPage,
});

function EchangesRetoursPage() {
  return (
    <HelpPage
      title="Échanges & retours"
      intro="Nous souhaitons que chaque commande SUNSET vous apporte entière satisfaction. Si vous rencontrez un problème avec votre commande, notre équipe est disponible pour vous accompagner."
    >
      <HelpSection title="Demande d'échange ou de retour">
        <p>
          Pour toute demande d'échange ou de retour, contactez notre équipe en précisant votre nom, votre numéro de
          téléphone et les informations relatives à votre commande.
        </p>
      </HelpSection>

      <HelpSection title="Conditions">
        <p>
          L'article doit être retourné dans son état d'origine, non porté, non lavé, non endommagé et avec ses
          éventuelles étiquettes et accessoires.
        </p>
        <p>
          Pour des raisons d'hygiène, certains articles peuvent ne pas être éligibles au retour ou à l'échange une fois
          portés ou utilisés.
        </p>
      </HelpSection>

      <HelpSection title="Article incorrect ou endommagé">
        <p>
          Si vous recevez un article incorrect ou présentant un défaut, contactez-nous dès que possible avec des photos
          afin que notre équipe puisse examiner votre demande et vous proposer une solution.
        </p>
      </HelpSection>

      <HelpSection title="Nous contacter">
        <p>
          Pour commencer une demande, utilisez la page <HelpLink to="/contact">Contact</HelpLink>.
        </p>
      </HelpSection>

      <HelpNote>
        Avant de commander, notre <HelpLink to="/guide-des-tailles">Guide des tailles</HelpLink> peut vous aider à
        choisir la bonne taille. Les informations de livraison sont détaillées sur la page{" "}
        <HelpLink to="/livraison">Livraison</HelpLink>.
      </HelpNote>
    </HelpPage>
  );
}
